import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { IconCirclePlus } from "@tabler/icons";
import { configState } from "../../../../recoil/atoms";
import { Grid, Button, Box, Modal } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import GrantAccessModel from "../FormModel/GrantAccessModel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModalLayout from "./../../../../utils/FormFields/ModalLayout";
import MainCard from "../../../../styles/ui-component/cards/MainCard";
import useAuthorization from "../../../Authentication/permissions/Authorization";
import RemoveEmployeeDialog from "../../../../utils/FormFields/RemoveEmployeeDialog";
import { BranchApi, EmployeeApi, GetBranchesResponse } from "../../../../api/clinic-management";

const EmployeeBranches = (props: any) => {
  const {employee} = props;
  const config = useRecoilValue(configState);
  
  const [rowID, setRowID] = useState<string>(""); 
  const [sameRole, setSameRole] = useState<boolean>(false);
  const [branchName, setBranchName] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [openModal, setOpenModal] = useState<boolean>(false); 
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [branches, setBranches]= useState<GetBranchesResponse>([]);  
  
  const userID = employee.User.UserID;
  const Specialty = employee.Speciality;
  const loggedEmployeeSpecialty = JSON.parse(localStorage.LoggedEmployee).Speciality;

  const { canRemoveEmployeeFromBranch, canGiveBranchAccess } = useAuthorization();
  
  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    setOpenModal(false);    
    getBranches();
  };

  const getBranches = () => {
    const branches = new BranchApi(config);
    branches.getAllBranchesOfUser(userID)
      .then((res) => {      
      setBranches(res.data);       
      })
      .catch((err) => {      
      toast.error(err?.response?.data?.detail);
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setSameRole(
      (loggedEmployeeSpecialty === "Assistant"  || loggedEmployeeSpecialty === "Admin") && 
      (Specialty === "Admin" || Specialty === "Assistant")
    );
    getBranches();    
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirm = () => {
    deleteEmployee(rowID);
    handleCloseDialog();
  };

  const handleRemove = (id: string) => {
    setRowID(id);
    handleOpenDialog();
  };

  const deleteEmployee = (branchID: string) => {
    const employee = new EmployeeApi(config);
    employee.removeEmployeeFromBranch(userID, branchID)
      .then((res) => {
        getBranches();
        toast.success(res?.data?.Message!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const columns = [
    {
      name: "BranchID",
      options: {
        display: false,
        filter: false,
        print: false,
        download: false,
      },
    },
    {
      name: "Name",
      label: "Branch Name",
    },
    {
      name: "Contact.Emails",
      label: "Email",
    },
    {
      name: "Contact.Website",
      label: "Website",
    },
    {
      name: "Address.City",
      label: "City",
    },
    {
      name: "action",
      label: "Action",
      print: false,
      options: {
        filter: false,
        sort: false,
        print: false,
        download: false,
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          <>        
            {canRemoveEmployeeFromBranch && !sameRole &&(
              <Tooltip title="Remove Employee from Branch">
                <Button
                  variant="outlined"
                  color="error"
                  sx={{
                    ml: { xs: 0, xl: 2 },
                  }}
                  onClick={() => {
                    handleRemove(tableMeta.rowData[0]);  
                    setBranchName(tableMeta.rowData[1]);                  
                  }}
                >
                  <DeleteOutlineIcon color="error" />
                </Button>
              </Tooltip>
            )}
          </>
        ),
      },
    },
  ];

  return (
    <>      
      <MainCard>
        <Grid>
          {!isLoading ? (
            <>            
              <Modal
                open={openModal}
                onClose={handleCloseModal}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <Box>
                  <ModalLayout>
                    <GrantAccessModel handleCloseModal={handleCloseModal} userID={userID}/>
                  </ModalLayout>
                </Box>
              </Modal>    
              <MUIDataTable
                data={branches}
                columns={columns}
                options={{
                  filter: false,
                  print: false,
                  download: false,
                  search: false,
                  viewColumns: false,
                  pagination: false,
                  selectableRows: "none",
                  selectableRowsOnClick: false,
                  elevation: 0,
                  rowsPerPage: 10,
                  filterType: "dropdown",
                  enableNestedDataAccess: ".",
                  responsive: "standard",
                  customToolbar: () => {
                    return (
                      <>
                        {canGiveBranchAccess && !sameRole && (
                          <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<IconCirclePlus />}
                            onClick={handleOpenModal}
                            sx={{
                            ml: "50px",
                            }}
                          >
                            Add Branch
                          </Button>
                        )}
                      </>
                    );
                  },
                }}
                title="Employee Branches"
              />
              <RemoveEmployeeDialog
                name={"Employee"}
                handleCloseDialog={handleCloseDialog}
                handleConfirm={handleConfirm}
                openDialog={openDialog} 
                branchName={branchName}                
              />
            </>
          ) : (
            <LinearProgress color="secondary" />
          )}
        </Grid>
      </MainCard>      
    </>
  )
};

export default EmployeeBranches;